import type { ReactNode } from 'react';
import { Header, type EyebrowTone, type TitleAccent } from './_shared';

export type SectionDividerProps = {
  eyebrow: ReactNode;
  eyebrowTone?: EyebrowTone;
  title: ReactNode;
  titleAccent?: TitleAccent;
  sub?: ReactNode;
  /** Optional huge faded numeral in the background (e.g. "01"). Decorative only. */
  watermark?: string;
};

export function SectionDivider({
  eyebrow,
  eyebrowTone,
  title,
  titleAccent,
  sub,
  watermark,
}: SectionDividerProps) {
  const bodyClass = watermark
    ? 'slide-body sn-divider sn-section-watermark'
    : 'slide-body sn-divider';
  return (
    <div className={bodyClass} data-watermark={watermark}>
      <Header
        eyebrow={eyebrow}
        eyebrowTone={eyebrowTone}
        title={title}
        titleAccent={titleAccent}
        sub={sub}
      />
      <div className="sn-work" />
    </div>
  );
}
